// Don't import from index so that we can keep bundle size as low as possible
// eslint-disable-next-line no-restricted-imports
import { getRecordedFeatureFlag } from '@trello/feature-flag-client/src/getRecordedFeatureFlag';
import { TrelloWindow } from '@trello/window-types';

import { getPreferredLocale } from './getPreferredLocale';
import { loadLocaleBundle } from './loadLocaleBundle';

declare const window: TrelloWindow;

let loader: Promise<void>;

export function loadPreferredLocaleBundle() {
  // We only want to load the preferred locale bundle once
  // per session to avoid conflicting code
  if (loader) {
    return loader;
  }

  if (
    getRecordedFeatureFlag('dlc.dynamic-locale-loading', 'false') === 'true'
  ) {
    const locale = getPreferredLocale();
    window.locale = locale;
    loader = loadLocaleBundle(locale);
  } else {
    loader = loadLocaleBundle(window.locale);
  }

  return loader;
}
